var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.35 100.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#41b883}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.08.12h23.27L58.17 100.47 0 .12h44.5l13.67 23.27L71.56.12z",
    transform: "translate(0 -.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 .12l58.17 100.35L116.35.12H93.08L58.17 60.33 23 .12z",
    transform: "translate(0 -.12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 .12l35.19 60.5L93.08.12H71.56L58.17 23.39 44.5.12z",
    transform: "translate(0 -.12)",
    fill: "#35495e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/vue.8ea27b3e7b243549883aacdb8a027a6f.svg";
export { ForwardRef as ReactComponent };